import { $api } from 'modules/global';

export const getPackagePrice = async () => {
  const { data } = await $api.get<Record<string, string>>('/get-premium-package-price');

  return { packagePrice: data };
};
